import { LicenseCardSimplifiedController } from './license-card-simplified.controller'

function licenseCardSimplified () {
  return {
    restrict: 'E',
    scope: {},
    templateUrl: '/admin/directives/license-card-simplified/license-card-simplified-directive.html?$$REVISION$$',
    controller: LicenseCardSimplifiedController
  }
}

export { licenseCardSimplified }
